import Api from "./Api";
import Utils from "../utilities/Utils";
import { News, NewsCenter } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class NewsCentersController extends Api {
  static getNewsCenter(id: string) {
    return fetch(`/api/news_centers/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getNewsCenters(params: object) {
    return fetch(`/api/news_centers?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(news_center: NewsCenter) {
    return fetch("/api/news_centers", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news_center: news_center }),
    }).then((res) => res.json());
  }

  static update(news_center: NewsCenter) {
    return fetch(`/api/news_centers/${news_center.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news_center: news_center }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/news_centers/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static bulkDelete(newsCenterIds: string[]) {
    return fetch(`/api/news_centers/bulk_delete`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news_center_ids: newsCenterIds }),
    }).then((res) => res.json());
  }

  static getForm(params: {
    id?: string;
  }): Promise<{ news_center: NewsCenter }> {
    return fetch(`/api/news_centers/form?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getView(
    newsCenterId: string,
    params = {}
  ): Promise<{
    news_center: NewsCenter;
    news: News[];
  }> {
    return fetch(
      `/api/news_centers/${newsCenterId}/view?${Utils.encodeQueryData(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
